<div #mapViewNode class="resultat-karta-base__esri-map">
  <div class="loading-mask" *ngIf="loading$ | async">
    <app-loader class="karta-loader"></app-loader>
    <div>Kartan laddas,</div>
    <div>detta kan ta en stund på Lands- och Landsdelsnivå</div>
  </div>
</div>
